import { ChangeEvent } from "react";

/*
range generates an array of ints, [start, end] (inclusive).
*/
const range = (start: number, end: number, length = end + 1 - start) =>
  Array.from({ length }, (_, i) => start + i);

const categories = [
  {
    name: "Fire Apparatus Technician Exams",
    exams: range(1, 6)
      .map((n) => `F${n}`)
      .concat("FA4")
      .concat(range(7, 8).map((n) => `F${n}`))
      .concat("GL")
      .concat("DO1"),
    descriptions: [
      "F1 covers the maintenance, inspection, and testing of fire apparatus as described in NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters)",
      "F2 covers the standards for fire apparatus as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters).",
      "F3 covers the standards as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters) and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In- Service Emergency Vehicles and Marine Firefighting Vessels(NFPA 1911 Chapters).Please note that this test draws from the 2024 editions.",
      "F4 covers the basic design and performance requirements of fire apparatus electrical systems, components of electrical systems, and preventive maintenance and troubleshooting activities.",
      "F5 covers the standards as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters) and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In - Service Emergency Vehicles and Marine Firefighting Vessels(NFPA 1911 Chapters).Please note that this test draws from the 2024 editions.",
      "F6 exam covers the servicing and maintenance, diagnostics and troubleshooting of Allison Automatic Transmissions AT, MT & HT series",
      "FA4 covers advanced electrical systems, including load managers, strobe systems, digital controls, multiplexing, and line voltage generating systems of emergency vehicles.",
      "",
      "",
      "GL tests knowledge of testing, maintenance and operation of ground ladders. The exam uses NFPA 1931: Standard for Manufacturers’ Design of Fire Department Ground Ladders and NFPA: 1932 Standard on Use, Mainteance, and Service Testing of In-Service Fire Department Ground Ladders.",
      "DO1 tests the knowledge of the Driver Operator to do a daily/weekly check that will satisfy the new requirements of NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters.) It is designed to be done without the use of a creeper and should be able to be completed in approximately one hour or less.",
    ],
    titles: [
      "Maintenance, Inspection, and Testing of Fire Apparatus",
      "Design and Performance Standards of Fire Apparatus",
      "Fire Pumps and Accessories",
      "Fire Apparatus Electrical Systems",
      "Aerial Fire Apparatus",
      "Allison Automatic Transmissions",
      "Advanced Electrical Systems",
      "Fire Apparatus Foam Systems",
      "Fire Apparatus Hydraulic Systems",
      "Ground Ladder Testing",
      "Driver Operator Inspection",
    ],
    prepGuides: [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
  },
  {
    name: "Ambulance Technician Exams",
    exams: range(0, 4).map((n) => `E${n}`),
    descriptions: [
      "E0 covers the maintenance, inspection, and testing of ambulances as covered in Meritor Preventive Maintenance and Lubrication, and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters)",
      "E1 covers the general design and performance standards for ambulances as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1917 Chapters).",
      "E2 covers the basic design and performance requirements of ambulance electrical systems, components of electrical systems, and preventive maintenance and troubleshooting activities.",
      "E3 covers basic design, requirements and components of ambulance HVAC systems.",
      "E4 covers the requirements for the systems that are unique to ambulances, as well as common chassis components.",
    ],
    titles: [
      "Maintenance, Inspection, and Testing of Ambulances",
      "Design & Performance Standards of Ambulances",
      "Ambulance Electrical Systems",
      "Ambulance Heating, Air-Conditioning, and Ventilation Systems",
      "Ambulance Cab, Chassis, and Powertrain",
    ],
    prepGuides: [false, false, false, false, false],
  },
  {
    name: "ARFF Technician Exams",
    exams: range(1, 3).map((n) => `A${n}`),
    descriptions: [
      "A1 covers the general design and performance standards for ARFF vehicles as described in FAA Advisory Circular 10c Guide Specifications for Water/Foam Aircraft Rescue and Fire-Fighting Vehicles, and the general principles of preventive maintenance and servicing.",
      "A2 covers the operation and testing of the chassis and vehicle components of ARFF vehicles, the operation of the vehicle systems and components, and inspections, maintenance, and repair of those components.",
      "A3 covers basic design requirements and components of ARFF vehicle extinguishment systems.",
    ],
    titles: [
      "Design & Performance Standards and Preventive Maintenance of Aircraft Rescue and Fire-Fighting Vehicles",
      "Chassis and Vehicle Components of Aircraft Rescue and Fire-Fighting Vehicles",
      "Extinguishment Systems of Aircraft Rescue and Fire-Fighting Vehicles",
    ],
    prepGuides: [false, false, false],
  },
  {
    name: "LEV Technician Exams",
    exams: range(1, 1).map((n) => `L${n}`),
    descriptions: [
      "L1 covers design and performance standards, installation of specialized systems and equipment, and the accepted practices of upfitting LE Vehicles.",
    ],
    titles: ["Law Enforcement Vehicle Installation"],
    prepGuides: [true],
  },
  {
    name: "Management Exams",
    exams: range(1, 2).map((n) => `M${n}`),
    descriptions: [
      "M1 is based on the principles published by the Association of Equipment Management Professionals (AEMP) in The Career Equipment Fleet Manager. Reference publication ordering information to prepare for the Management Exam is listed at the top of the page of the exam’s learning objectives.",
      "M2 is (same as M1) based on the principles published by the Association of Equipment Management Professionals (AEMP) in The Career Equipment Fleet Manager. Reference publication ordering information to prepare for the Management Exam is listed at the top of the page of the exam’s learning objectives.",
    ],
    titles: ["Management Level 1", "Management Level 2"],
    prepGuides: [false, false],
  },
];

const allExams: string[] = [];
categories.forEach((cat) => {
  cat.exams.forEach((exam) => {
    allExams.push(exam);
  });
});

export default function Exams() {
  const jumpToTest = (evt: ChangeEvent<HTMLSelectElement>) => {
    document
      .getElementById((evt.target as HTMLSelectElement).value)
      ?.scrollIntoView({
        behavior: "smooth",
      });
  };

  return (
    <>
      <header className="relative w-full border-b border-b-black bg-gray-200 py-2">
        <section className="mx-auto max-w-[85rem]">
          <h2 className="text-center font-serif text-[110%] font-bold italic md:text-xl">
            Emergency Vehicle Technician Certification Commission
          </h2>
        </section>
      </header>
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              Exams &amp; Prep
            </h1>
            <p className="my-2">
              Here you will find brief descriptions of all EVTCC tests, as well
              as our &ldquo;Reference Materials and Learning Objectives&rdquo;
              and &ldquo;Sample Questions&rdquo; documents for each test.
            </p>
            <h2 className="my-2 mt-4 font-serif text-2xl font-bold italic text-(--darkred)">
              Quick Facts
            </h2>
            <ul className="ml-8 list-disc">
              <li>Save 10% on registration costs by registering online.</li>
              <li>
                <a
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                  href="https://register.evtcc.org"
                >
                  Online registrations
                </a>{" "}
                are due 16 days prior to the test date.
              </li>
              <li>
                <a
                  className="text-(--themered) hover:text-(--darkred) hover:underline"
                  href="/downloads/EVTCC-Exam-Registration.pdf"
                >
                  Form registrations
                </a>{" "}
                must be <em>received</em> (fax, mail, or email) 21 days prior to
                the test date.
              </li>
              <li>
                You must have your Confirmation/Admittance letter to gain
                admittance to your exam. Contact the EVTCC office if you have
                not received your Confirmation/Admittance letter by 16 days
                prior to the test date.
              </li>
              <li>A 70% score or better is required to pass each test.</li>
              <li>
                Results will be mailed within 4-6 weeks after the test date.
              </li>
              <li>Certifications are valid for 5 years.</li>
            </ul>
          </section>
          <h2 className="my-2 mt-4 font-serif text-2xl font-bold italic text-(--darkred)">
            Jump to an exam
          </h2>
          <select
            name="jump-to-test"
            onChange={(e) => jumpToTest(e)}
            className="my-2 block rounded-lg border-2 border-gray-500 px-4 py-3 pe-9 text-xl focus:border-red focus:ring-red md:text-base"
          >
            {allExams.map((ex) => (
              <option value={ex} key={ex}>
                {ex}
              </option>
            ))}
          </select>

          {categories.map((category) => {
            return (
              <section key={category.name}>
                <h2 className="my-2 mt-8 font-serif text-2xl font-bold italic text-(--darkred)">
                  {category.name}
                </h2>
                {category.exams.map((exam, i) => {
                  const desc = category.descriptions[i];
                  return (
                    <div className="mb-6 ml-4" key={exam}>
                      <h3
                        className="my-4 inline font-serif text-xl font-bold italic"
                        id={exam}
                      >
                        {exam}&nbsp;&ndash;&nbsp;{category.titles[i]}
                      </h3>
                      &nbsp;
                      <span>
                        {desc ? desc.substring(desc.indexOf(" ") + 1) : <></>}
                      </span>
                      <ul className="ml-6 mt-2 list-disc">
                        <li>
                          <a
                            className="text-(--themered) hover:text-(--darkred) hover:underline"
                            href={`/downloads/tests/${exam}-Ref.pdf`}
                          >
                            {exam} Reference Materials and Learning Objectives
                          </a>
                        </li>
                        <li>
                          <a
                            className="text-(--themered) hover:text-(--darkred) hover:underline"
                            href={`/downloads/tests/${exam}-SampleQuestions.pdf`}
                          >
                            {exam} Sample Questions
                          </a>
                        </li>
                        {category.prepGuides[i] ? (
                          <li>
                            <a
                              className="text-(--themered) hover:text-(--darkred) hover:underline"
                              href={`/downloads/tests/${exam}-PrepGuide.pdf`}
                            >
                              {exam} Prep Guide
                            </a>
                          </li>
                        ) : (
                          <></>
                        )}
                      </ul>
                    </div>
                  );
                })}
              </section>
            );
          })}
          <section className="mt-6 py-2"></section>
        </div>
      </main>
    </>
  );
}
